import React  from 'react'
import { UilSearch,UilLocationPoint } from '@iconscout/react-unicons'
import { useState } from 'react'
import {toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
function Inputs({setQuery ,units ,setUnits}) {
  const [city, setCity] = useState("")
  console.log(city)
  const handleSearchclick=()=>{
      if(city!=='') setQuery({q:city})
  }
  const handleLocationclick=()=>{
    toast.info("fetching current location")
    if(navigator.geolocation){
      navigator.geolocation.getCurrentPosition((position)=>{
        toast.success("Fetched current Location")
        let lat=position.coords.latitude;
        let lon=position.coords.longitude;
        console.log(lat,lon)
        setQuery({
          lat,lon,
        });
      })
    };
  }
  const handleUnitclick=(e)=>{
    const selectedunit=e.currentTarget.name
    if(units!==selectedunit)setUnits(selectedunit);
  };
  return (
    <div className='flex flex-row justify-center my-6'>
        <div className='flex flex-row w-3/4 items-center justify-center space-x-4'>
            <input 
            value={city}
            onChange={(d)=>setCity(d.currentTarget.value)}
            
            type="text" 
            placeholder='search your city...'
            className='text-xl font-light p-2 w-full shadow-xl focus:outline-none capitalize placeholder:lowercase'

            />
            <UilSearch
            
            size={25}
            className='text-white cursor-pointer transition ease-out hover:scale-150'
            onClick={handleSearchclick}
            />
            <UilLocationPoint
            size={25}
            className='text-white cursor-pointer transition ease-out hover:scale-150'
            onClick={handleLocationclick}
            />
        </div>
        <div className='flex flex-row w-1/4 items-center justify-center space-x-4'>
            <button  onClick={handleUnitclick}  name='metric' className='text-white cursor-pointer transition ease-out hover:scale-150'>°C</button>
            <p className='text-white text-xl mx-1'>|</p>
            <button  onClick={handleUnitclick} name='imperial' className='text-white cursor-pointer transition ease-out hover:scale-150'>°F</button>
        </div>
    </div>
  )
}

export default Inputs